import { useEffect } from 'react'

// eslint-disable-next-line import/prefer-default-export
export const useVersionChecker = () => {
  useEffect(() => {
    // const checkVersion = async () => {
    //   console.log('checking version')

    //   console.log({ version: process.env.REACT_APP_VERSION })

    //   try {
    //     const response = await fetch(`/meta.json?_=${new Date().getTime()}`)
    //     const data = await response.json()

    //     if (data.version !== process.env.REACT_APP_VERSION) {
    //       console.log('[App] New version detected. Reloading...')
    //       window.location.reload(true)
    //     } else {
    //       console.log('Version OK')
    //     }
    //   } catch (err) {
    //     console.error('Version check failed:', err)
    //   }
    // }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        window.location.reload()
        //  checkVersion()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}
